(function () {
  function initCtrlpGrid() {
    var cards = document.querySelectorAll('.ctrlp-card:not([data-ctrlp-bound])');
    if (!cards.length) return;

    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (card) {
        card.classList.add('ctrlp-in-view');
        card.setAttribute('data-ctrlp-bound', 'true');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ctrlp-in-view');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    cards.forEach(function (card) {
      card.setAttribute('data-ctrlp-bound', 'true');
      io.observe(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCtrlpGrid);
  } else {
    initCtrlpGrid();
  }

  // Re-init when merchant edits this section in the theme editor
  document.addEventListener('shopify:section:load', initCtrlpGrid);
})();